import React, { useReducer } from 'react'
import { TypePositionContext } from '../context/useTypePosition'
import { typePositionReducer, initialState } from '../reducer/typePositionReducer'

/*
 * Copyright 2022-11-18 por alfonso moya Ecomsur Holding S.A ©
 * Detalle:
 */

export const TypePositionProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(typePositionReducer, initialState)

  const value = { state, dispatch }

  return <TypePositionContext.Provider value={value}>{children}</TypePositionContext.Provider>
}
